"use client";

import { formatRelativeTime } from "utils/formatRelativeTime";
import { useHydrated } from "modules/common/hooks/useHydrated";

/**
 * Hydration-safe relative time. ISR/SSR bakes a possibly stale value into the
 * HTML; suppressHydrationWarning stops React treating the recomputed client
 * value as a mismatch (which would force a full client re-render).
 *
 * React accepts the server's text without patching it, though, so recomputing
 * on mount is not enough on its own — the fresh string equals what the
 * hydration render already produced, and the no-op diff leaves the stale text
 * in the DOM. Flipping the key after hydration remounts the element so the
 * recomputed value actually lands.
 */
export const RelativeTime = ({
  date,
  className,
}: {
  date: Date | string | number;
  className?: string;
}) => {
  const hydrated = useHydrated();

  return (
    <span
      key={hydrated ? "fresh" : "ssr"}
      suppressHydrationWarning
      className={className}
    >
      {formatRelativeTime(date)}
    </span>
  );
};
